const localStorage = window.localStorage


export default {

    staticPath: '',

    /**
     * 获取cgi请求地址
     */
    getCgiHost() {
        return this.getHost() + '/cgi';
    },

    /**
     * 获取网站地址
     */
    getHost() {
        let host = 'http://website.seabury.dev.sfitech.cn';

        if (window.location.hostname != 'localhost' && window.location.port == '') {
            host = window.location.origin;
        }

        return host;
    },

    /**
     * 验证Token
     */
    checkToken(store) {
        if (store && store.state && !store.state.token) {
            var storage = localStorage.getItem("sfyStorage");
            // console.log('storage,:',storage)
            if (storage) {
                storage = JSON.parse(storage);
                if (storage && storage.token) {
                    // store.replaceState(Object.assign(store.state, storage));
                    store.state.token = storage.token
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        }
    },

    setUser(store){
        var storage = localStorage.getItem("sfyStorage");
        if(storage){
            storage = JSON.parse(storage);
            // console.log('getUserInfo:---',storage.userInfo)
            store.state.userInfo = storage.userInfo;
            store.state.userMemorialId = storage.userMemorialId;
        }
    },

    /**
     * 设置localstroage的值
     * @param {String} item
     * @param {Object} obj
     */
    setLocalStroageData(item, obj) {
        localStorage.setItem(item, JSON.stringify(obj))
    },

    getLocalStroageUUID() {
        var clientCode = localStorage.getItem('__c__c');
        if (!clientCode) {
            clientCode = this.createUIID();
            localStorage.setItem('__c__c', clientCode);
        }
        return clientCode;
    },
    createUIID() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    },

    //-- 浏览器工具 --> --//
    browser :{
        // 检测是否是IE浏览器
        isIE: function() {
            var _uaMatch = uaMatch(navigator.userAgent);
            var _browser = _uaMatch.browser;
            if(_browser == 'msie' || _browser=='trident') {
                return true;
            } else {
                return false;
            }
        },
        // 检测是否是chrome浏览器
        isChrome: function() {
            var _uaMatch = uaMatch(navigator.userAgent);
            var _browser = _uaMatch.browser;
            if(_browser == 'webkit') {
                return true;
            } else {
                return false;
            }
        },
        // 检测是否是Firefox浏览器
        isMozila: function() {
            var _uaMatch = uaMatch(navigator.userAgent);
            var _browser = _uaMatch.browser;
            if(_browser == 'mozilla') {
                return true;
            } else {
                return false;
            }
        },
        // 检测是否是Opera浏览器
        isOpera: function() {
            var _uaMatch = uaMatch(navigator.userAgent);
            var _browser = _uaMatch.browser;
            if(_browser == 'opera') {
                return true;
            } else {
                return false;
            }
        },
        // 判断当前是否在微信环境中
        isWeiXin: function () {
            return navigator.userAgent.match('MicroMessenger');
        },
        // 判断当前是否在移动设备中
        isMobile: function () {
            return navigator.userAgent.match('iPad|iPhone|iPod|Android|MicroMessenger');
        },
        // 判断当前是否在移动设备中
        isIOS: function () {
            return navigator.userAgent.match('iPad|iPhone|iPod');
        },
        // 判断操作系统类型
        detectOS: function () {
            var sUserAgent = navigator.userAgent;
            var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
            var isMac = navigator.platform.indexOf('Mac') != -1;
            if(isMac) return "Mac";
            var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
            if(isUnix) return "Unix";
            if(isWin) {
                var isWin95 = sUserAgent.indexOf("Win95") > -1 || sUserAgent.indexOf("Windows 95") > -1;
                if(isWin95) return "Win95";
                var isWin98 = sUserAgent.indexOf("Win98") > -1 || sUserAgent.indexOf("Windows 98") > -1;
                if(isWin98) return "Win98";
                var isWinME = sUserAgent.indexOf("Windows 9x 4.90") > -1 || sUserAgent.indexOf("Windows ME") > -1;
                if(isWinME) return "WinME";
                var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
                if(isWin2K) return "Win2000";
                var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
                if(isWinXP) return "WinXP";
                var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
                if(isWin7) return "Win7";
                var isWin8 = sUserAgent.indexOf("Windows NT 8") > -1 || sUserAgent.indexOf("Windows 8") > -1;
                if(isWin8) return "Win8";
                var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
                if(isWin10) return "Win10";
                return 'Windows';
            }
            return "None";
        },
        // 获取URL中的参数Map
        getUrlParam: function () {
            var params = location.search;
            var pMap = [];

            if (params.indexOf("?") == -1) {
                params = location.href.substr(location.href.indexOf('?'));
            }

            if (params.indexOf("?") != -1) {
                params = params.substr(1).split("&");

                for (var i = 0; i < params.length; i++) {
                    var param = params[i].split('=');
                    pMap[param[0]] = param[1];
                }
            }

            return pMap;
        }
    },
    //-- <-- 浏览器工具 --//
    getPageId(){
        var locaArr = location.hash.split('/');
        return locaArr[locaArr.length-1]

    },
    deepClone(data){
        return JSON.parse(JSON.stringify(data))
    },
    getImgSize:function(file,callback){
        var image = new Image();
        image.onload = function () {
            var width  = this.width;
            var height = this.height;
            if(callback) callback(width,height)
        };
        image.src = file;
    },
    parseImgStyle(w,h,scope,el){
        if(w>h){
            scope[el].height='100%'
            scope[el].width='auto'
        }else if(w<h){
            scope[el].width='100%'
            scope[el].height='auto'
        }else{
            scope[el].height='100%'
            scope[el].width='100%'
        }
    },

}
